import cx from 'clsx';

import { isMoreThan } from '~/utils/number';

import type { ProductPriceProps } from '.';

export default function RegularProductPrice({
  className,
  price,
  priceBeforeDiscount,
  is3x2 = false,
}: ProductPriceProps) {
  return (
    <p
      className={cx('mt-4 flex flex-col text-normal', className)}
      style={
        is3x2
          ? {
              fontSize: 16,
              fontWeight: 700,
              lineHeight: '20px',
            }
          : {
              fontSize: 14,
              fontWeight: 700,
              lineHeight: '18px',
            }
      }
    >
      {price === 0 ? (
        '상담신청 상품'
      ) : (
        <>
          {price.toLocaleString()}원
          {isMoreThan(priceBeforeDiscount, price) && (
            <span className="text-description typo-footnote300-regular">
              {priceBeforeDiscount.toLocaleString()}원
            </span>
          )}
        </>
      )}
    </p>
  );
}
